import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../Boilerplate/BreadcrumbContext";
import ProjectList from "./ProjectList";
import Project from "./Project";
import ProjectNew from "./ProjectNew";

class Projects extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Projects</title>
        </Helmet>
        <Route exact path="/projects" component={ProjectList}/>
        <Switch>
          <Route path="/projects/new" component={ProjectNew}/>
          <Route path="/projects/:id" component={Project}/>
        </Switch>
      </div>
    );
  }
}

export default withBreadcrumb({title: 'Projects', path: '/projects/'}, Projects);



// WEBPACK FOOTER //
// ./src/components/Projects/Projects.js